module.exports = __webpack_public_path__ + "bee04b22e5ecd55b9f87cf4f702c8c3c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/danh-sach-doanh-nghiep.svg
// module id = ./assets/images/danh-sach-doanh-nghiep.svg
// module chunks = 0